import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonLink from 'components/theme_components/ButtonLink';
import FormInput from 'components/FormInput';
import TextArea from 'rc-textarea';

interface TabForceAcceptanceProps {
  form?: any;
  onDone: any;
  onCancel: any;
  dataInput?: any;
}

const TabForceAcceptance: React.FC<TabForceAcceptanceProps> = ({
  form,
  onDone,
  onCancel,
  dataInput,
}) => {
  const [ctrid, setCtrid] = useState<string | undefined>(undefined);
  const [action, setAction] = useState('');
  const [internalForm] = Form.useForm();
  const usedForm = internalForm;
  console.log('Selected:', dataInput);
  const handleValidate = () => {
    onDone();
  };
  useEffect(() => {
    usedForm.setFieldsValue({
      event: 'evForceAcceptance',
      action: 'ACCEPT',
      ctrid: dataInput?.[0]?.ctrid,
    });
  }, [usedForm, dataInput]);

  return (
    <Form form={usedForm} layout="vertical" className="no-border-radius">
      <div
        className="modal-title"
        style={{ fontWeight: 600, fontSize: 20, marginBottom: 24 }}
      >
        Gérer l'anomalie de réservation
      </div>
      <FormInput name="action"  style={{ marginBottom: 16 }}>
        <Select className="no-border-radius" onSelect={(e:any)=>{setAction(e)}}>
          <Select.Option value="ACCEPT">Forcer l'acceptation</Select.Option>
        </Select>
      </FormInput>

      <FormInput name="comment" nolabel style={{ marginBottom: 16 }}>
        <Input.TextArea
          rows={4}
          style={{ marginBottom: 16, resize: 'none' }}
          className="no-border-radius"
        />
      </FormInput>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <ButtonLink
          comcode="Annuler"
          type="default"
          className=" ut-btn-bordred"
          onClick={onCancel}
        />
        <ButtonLink
          comcode="Valider"
          type="primary"
          className="no-border-radius"
          onClick={handleValidate}
          disabled={action===""}
        />
      </div>
    </Form>
  );
};

export default TabForceAcceptance;
